import { useEffect, useRef, useState } from "react";
import {
  TextField,
  FormControl,
  MenuItem,
  Select,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import backarr from '../../Images/Layer2.svg'
import { Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllTicketList, getAllTicketTypeList } from "../../Actions/SupportAction";
import { createTicket } from "../../Services/support";
import { ToastError, ToastSuccess } from "../../CustomToaster/CustomToaster";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { getAllAssetList } from "../../Actions/AssetsListAction";

const faqs = [
  {
    question: "Where can I use these keys?",
    answer:
      "These keys can be used for API authentication in your EMRT campaigns.",
  },
  {
    question: "What are the fees? ",
    answer:
      "We are charging two fees while withdrawal. Transaction Fee and Processing fees. ",
  },
  {
    question: "What are withdrawal limits for all coins/tokens?",
    answer:
      "There is a $10000 (Equivalent of coin/token) withdrawal limit per day for every coin/token wallet. If you want to increase that limit then please create a ticket. Mention your wallet name and limit you want to set. ",
  },
  {
    question:
      "My customer has been paid the full amount on the invoice but the invoice expires, Why?",
    answer:
      "You can set invoice expiry time while creating an invoice. If the customer sends full payment after the invoice expires, the Invoice status will not change but the fund will deposit on your wallet. ",
  },
];

const AddTicket = () => {
  const [ticketType, setTicketType] = useState("others");
  const [coin, setCoin] = useState("");
  const [title, setTitle] = useState("");
  const [transId, setTransId] = useState("");
  const [description, setDescription] = useState("");
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();


  //custom code
  const [load, setLoad] = useState(false);
  const hasFetchedType = useRef(false);
  const dispatch = useDispatch();

  const { ticketTypeLoading, ticketTypeData, ticketTypeError, ticketTypeStatus, } = useSelector((state) => state.support);
  const { assetListData, assetListError, assetListLoading, assetListStatus } = useSelector((state) => state.assetList);

  const [errors, setErrors] = useState({
    title: "",
    description: "",
    txnId: "",
    amount: "",
    fromAddress: "",
    toAddress: "",
    coin: "",
    network: "",
    date: "",
    reason: ""
  });
  const [ticketTypeList, setAllTicketTypeList] = useState([]);
  const [ticketDetail, setTicketDetail] = useState({
    title: "",
    description: "",
  });
  const [fields, setFields] = useState([]);
  const [formData, setFormData] = useState({
    txnId: "",
    amount: "",
    fromAddress: "",
    toAddress: "",
    coin: "",
    network: "",
    date: dayjs(),
    reason: ""
  });
  const [assetList, setAssetList] = useState([])


  useEffect(() => {
    if (!ticketTypeData && !hasFetchedType.current) {
      const data = { userType: "user" };
      dispatch(getAllTicketTypeList(data));
      hasFetchedType.current = true; // Prevent repeat fetches even if it fails
    }
  }, [ticketTypeData, dispatch]);

  useEffect(() => {
    if (ticketTypeStatus === true) {
      setAllTicketTypeList(ticketTypeData?.result);
    } else {
    }
  }, [ticketTypeStatus]);

  useEffect(() => {
    dispatch(getAllAssetList());
  }, [])

  useEffect(() => {
    if (assetListStatus === true) {
      setAssetList(assetListData?.result)


    } else {
    }
  }, [assetListStatus]);

  const handleTicketTypeChange = (e) => {
    setTicketType(e.target.value);
    setFormData({
      txnId: "",
      amount: "",
      fromAddress: "",
      toAddress: "",
      coin: "",
      network: "",
    });
    if (e.target.value === "others") {
      setFields([]);
      return;
    }
    ticketTypeList?.map((item, index) => {
      if (item?.type === e.target.value) {
        setFields(item?.fields);
      }
    });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setTicketDetail({ ...ticketDetail, [name]: value });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "title") {
      if (value != "" && value.length < 5) {
      }
    }
    if (fieldName === "description") {
      if (value != "" && value.length < 5) {
      } else if (/^\d{0,49}$/.test(value)) {
        e.preventDefault();
        errorMessage = "only allow 50 characters";
        isValid = false;
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    if (!ticketDetail.title) {
      formErrors.title = "Title is required";
      isValid = false;
    } else if (ticketDetail.title?.length < 5) {
      formErrors.title = "Title must be at least 5 characters long";
      isValid = false;
    }

    if (!ticketDetail.description) {
      formErrors.description = "Description is required";
      isValid = false;
    } else if (ticketDetail.description.length < 6) {
      formErrors.description = "Description must be at least 6 characters long";
      isValid = false;
    }

    // Dynamic validation for fields in the `fields` array
    fields.forEach((field) => {
      if (field === "txnId" && !formData.txnId) {
        formErrors.txnId = "Transaction Id is required";
        isValid = false;
      }

      if (field === "Amount" && !formData.amount) {
        formErrors.amount = "Amount is required";
        isValid = false;
      } else if (
        field === "amount" &&
        formData.amount &&
        formData.amount <= 0
      ) {
        formErrors.amount = "Amount must be greater than 0";
        isValid = false;
      }

      if (field === "FromAddress" && !formData.fromAddress) {
        formErrors.fromAddress = "From Address is required";
        isValid = false;
      } else if (
        field === "FromAddress" &&
        formData.fromAddress &&
        formData.fromAddress.length < 6
      ) {
        formErrors.fromAddress =
          "From Address must be at least 6 characters long";
        isValid = false;
      }

      if (field === "ToAddress" && !formData.toAddress) {
        formErrors.toAddress = "To Address is required";
        isValid = false;
      } else if (
        field === "ToAddress" &&
        formData.toAddress &&
        formData.toAddress.length < 6
      ) {
        formErrors.toAddress =
          "From Address must be at least 6 characters long";
        isValid = false;
      }
      if (field === "Coin" && !formData.coin) {
        formErrors.coin = "select the coin";
        isValid = false;
      }
      if (field === "Network" && !formData.network) {
        formErrors.network = "Select the network";
        isValid = false;
      }
      if (field === "Date" && !formData.date) {
        formErrors.date = "select the Date";
        isValid = false;
      }
    });

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      const keyValuePairs = Object.keys(formData)
        .filter(
          (key) =>
            formData[key] !== "" &&
            formData[key] !== null &&
            formData[key] !== undefined
        ) // Remove empty values
        .map((key) => ({
          [key]: formData[key],
        }));
      const data = {
        title: ticketDetail?.title,
        description: ticketDetail?.description,
        category: ticketType,
        values: ticketType != "others" && keyValuePairs,
        type: "user",
      };

      const response = await createTicket(data);
      if (response?.data?.success === true) {
        ToastSuccess({ message: response?.data?.message, icon: false });

        setLoad(false);
        navigate('/support')
        dispatch(getAllTicketList())

      } else {
        ToastError({ message: response?.data?.message, icon: false });

        setLoad(false);
      }
    }
  };


  const handleReset = () => {
    setTicketType("others");
    setCoin("");
    setTitle("");
    setTransId("");
    setDescription("");
    setFormData({
      txnId: "",
      amount: "",
      fromAddress: "",
      toAddress: "",
      coin: "",
      network: "",
    });
    setTicketDetail({
      title: "",
      description: "",
    })

  };



  return (
    <div className="create-ticket">
      <Container className="xl-box" maxWidth="xl">
        <Grid container spacing={4}  >
          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <div className="back" onClick={() => navigate(-1)}>
              <div className="text-left"><a><img src={backarr} /></a></div>
            </div>
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
            <div className="card-box">
              <div className="email-fill ">
                <div className="input-common">
                  <label >Title *</label>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                    onChange={handleChange}
                    onInput={validateFocus}
                    error={!!errors.title}
                    helperText={errors.title}
                    value={ticketDetail.title}
                    name="title"
                  />
                </div>

              </div>

              <div className="select-type input-common">
                <label className="email-name commom-select">Type</label>
                <FormControl fullWidth sx={{ margin: "10px 0" }}>
                  <Select
                    onChange={handleTicketTypeChange}
                    value={ticketType}
                    name="ticketType"
                    displayEmpty
                  >
                    <MenuItem value="others">Others</MenuItem>
                    {ticketTypeList?.length > 0 &&
                      ticketTypeList?.map((item, index) => (
                        <MenuItem
                          key={item?.type}
                          value={item?.type}
                        >
                          {item?.type}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>

              {fields.includes("txnId") && (
                <div className="email-fill ">
                  <div className="input-common">
                    <label >Transaction Id</label>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      autoFocus
                      placeholder="Enter Transaction Id"
                      onChange={handleInputChange}
                      error={!!errors.txnId}
                      helperText={errors.txnId}
                      value={formData.txnId}
                      name="txnId"
                      type="number"
                    />
                  </div>

                </div>
              )}
              {fields.includes("Amount") && (
                <div className="email-fill ">
                  <div className="input-common">
                    <label >Amount</label>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      autoFocus
                      placeholder="Enter Amount"
                      onChange={handleInputChange}
                      error={!!errors.amount}
                      helperText={errors.amount}
                      value={formData.amount}
                      name="amount"
                      type="number"
                    />
                  </div>

                </div>
              )}
              {fields.includes("FromAddress") && (
                <div className="email-fill ">
                  <div className="input-common">
                    <label >From Address</label>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      autoFocus
                      placeholder="Enter From Address"
                      onChange={handleInputChange}
                      error={!!errors.fromAddress}
                      helperText={errors.fromAddress}
                      value={formData.fromAddress}
                      name="fromAddress"
                      type="text"
                    />
                  </div>

                </div>
              )}
              {fields.includes("ToAddress") && (
                <div className="email-fill ">
                  <div className="input-common">
                    <label >To Address</label>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      autoFocus
                      placeholder="Enter To Address"
                      onChange={handleInputChange}
                      error={!!errors.toAddress}
                      helperText={errors.toAddress}
                      value={formData.toAddress}
                      name="toAddress"
                      type="text"
                    />
                  </div>

                </div>
              )}
              {fields.includes("Coin") && (
                <div className="select-type input-common">
                  <label className="email-name commom-select">Coin</label>
                  <FormControl fullWidth sx={{ margin: "10px 0" }}>
                    <Select
                      value={formData.coin}
                      name="coin"
                      onChange={handleInputChange}
                      displayEmpty
                    >
                      {assetList?.length > 0 &&
                        assetList?.map((item, index) => (
                          <MenuItem
                            key={index}
                            value={item?.source}
                          >
                            {item?.name} ({item?.source})
                          </MenuItem>
                        ))}

                    </Select>
                  </FormControl>
                  <span
                    style={{
                      color: "#d32f2f",
                      fontSize: 13,
                      fontWeight: "bold",
                    }}
                  >
                    {errors.coin}
                  </span>{" "}
                </div>
              )}
              {fields.includes("Network") && (
                <div className="select-type input-common">
                  <label className="email-name commom-select">Network</label>
                  <FormControl fullWidth sx={{ margin: "10px 0" }}>
                    <Select
                      value={formData.network}
                      name="network"
                      onChange={handleInputChange}
                      displayEmpty
                    >
                      {assetList?.length > 0 &&
                        [
                          ...new Set(
                            assetList
                              ?.filter(item => item?.network?.trim())
                              .map(item => item.network.trim())
                          )
                        ].map((network, index) => (
                          <MenuItem key={network} value={network}>
                            {network}
                          </MenuItem>
                        ))}


                    </Select>
                  </FormControl>
                  <span
                    style={{
                      color: "#d32f2f",
                      fontSize: 13,
                      fontWeight: "bold",
                    }}
                  >
                    {errors.network}
                  </span>{" "}
                </div>
              )}

              {fields.includes("Date") && (
                <div className="email-fill ">
                  <div className="input-common">
                    <label >Date</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={[
                          "DatePicker",
                          "MobileDatePicker",
                          "DesktopDatePicker",
                          "StaticDatePicker",
                        ]}
                      >
                        <DemoItem>
                          <DatePicker
                            sx={{ color: "#fff" }}
                            name="date"
                            value={formData?.date}
                            onChange={(newValue) => {
                              setFormData({
                                ...formData,
                                date: newValue
                              })
                              setErrors({
                                ...errors,
                                date: ""
                              })
                            }}

                          />
                        </DemoItem>
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                  <span
                    style={{
                      color: "#d32f2f",
                      fontSize: 13,
                      fontWeight: "bold",
                    }}
                  >
                    {errors.date}
                  </span>{" "}
                </div>
              )}

              {fields.includes("Reason") && (
                <div className="email-fill ">
                  <div className="input-common">
                    <label >Reason</label>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      autoFocus
                      rows={4}
                      name="reason"
                      onChange={handleInputChange}
                      error={!!errors.reason}
                      helperText={errors.reason}
                      inputProps={{
                        maxLength: 50,
                      }}
                      value={formData.reason}
                      sx={{ margin: "10px 0" }}
                    />
                  </div>

                </div>
              )}


              <div className="email-fill">
                <div className="input-common">
                  <label className="email-name">Enter Description</label>
                  <TextField
                    multiline
                    fullWidth
                    rows={4}
                    name="description"
                    required
                    onChange={handleChange}
                    onInput={validateFocus}
                    error={!!errors.description}
                    helperText={errors.description}
                    inputProps={{
                      maxLength: 50,
                    }}
                    value={ticketDetail.description}
                    sx={{ margin: "10px 0" }}
                  />
                </div>

              </div>
              <div className="display-3">
                <div className="blu-btn mt-10">
                  {
                    load === true ?
                      <Button
                        disabled
                      >
                        Progressing
                      </Button>
                      :
                      <Button
                        onClick={(e) => {
                          handleSubmit(e)
                        }}
                      >
                        Submit
                      </Button>
                  }
                </div>
                <div className="blu-bdr mt-10">
                  <Button
                    onClick={handleReset}
                  >
                    Reset
                  </Button>
                </div>
              </div>

            </div>
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }} className="create-ticket">
            <h3 className="gold-color">
              Frequently Asked Questions
            </h3>

            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                onChange={() => setExpanded(expanded === index ? false : index)}
                sx={{
                  marginBottom: "20px",
                  marginTop: "20px",
                  boxShadow: "none",
                  border: "none",
                  background: "none",
                  "&::before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: 'var(--color-PrimaryText)' }} />}>
                  <h4 >{faq.question}</h4>
                </AccordionSummary>
                <AccordionDetails>
                  <p style={{ fontSize: '14px' }}>{faq.answer}</p>
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>

        </Grid>

      </Container>
    </div>
  );
};

export default AddTicket;
